import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../../configs/WebServiceUrl";
import { apiKeyHeader } from "../../../configs/ApiKeys";

// const BASE_URL = "https://web1024.docmaster.in:5010";
//  const BASE_URL = "http://localhost:5010";
const api = axios
export const createEventRequestThunk = createAsyncThunk(
  "eventRequest/create",
  async (eventData, { rejectWithValue }) => {
    try {
      const response = await api.post(
        `${BASE_URL}/event-request/create`,
        eventData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const fetchEventRequestsThunk = createAsyncThunk(
  "eventRequests/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${BASE_URL}/event-request/all`, {
        headers: apiKeyHeader(),
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
export const updateEventRequestThunk = createAsyncThunk(
  "eventRequest/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await api.put(
        `${BASE_URL}/event-request/update/${id}`,
        data
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
